// customSelect();
// calculatorConditional();
//
// function customSelect(){
//     jQuery('.js-select').each(function(){
//         jQuery(this).select2();
//     });
// }
//
// function calculatorConditional() {
//     jQuery('.calculator-form input[type="radio"]').on('change', function(e){
//         var id = jQuery(this).attr('id');
//         var name = jQuery(this).attr('name');
//         if(jQuery(this).val() == 'yes') {
//             jQuery('.calculator-form [data-id="'+id+'"]').removeClass('hidden');
//         } else {
//             jQuery('.calculator-form [data-name="'+name+'"]').addClass('hidden');
//         }
//     });
// }

popup();

function popup() {
    var popup = jQuery('.js-popup');

    jQuery('.js-arrange-viewing').on('click', function(e){
        popup.addClass('active')
    });

    jQuery('.js-popup-close').on('click', function(e){
        popup.removeClass('active');
        var url = window.location.href;
        var newURL = url.replace(/\?alert.*/, '');
        window.history.pushState(null, null, newURL);
    });
}
